'use strict';

intellidealerAppCoreModule.filter('cdkTime', function ($filter) {
    return function (input, format) {
        return input ? $filter('date')(new Date(input), format ? format : 'hh:mm a') : '';
    };
});
